import { Sites, SiteConstants } from '@labradorsports/constants';
import { SportRenderingConfigs } from '@labradorsports/play-rendering';
import SportConfigs from '@labradorsports/sports';

export const Config = SportConfigs[Sites.lacrosselab];
export const RenderingConfig = SportRenderingConfigs[Sites.lacrosselab];
export const TestUrl = SiteConstants[Sites.lacrosselab].TestUrl;
